module.exports = __webpack_public_path__ + "img/vanuatu.744d5b91.svg";